/* Unified progressive enhancements; no server-side data collection. */
(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const header = $('.header');
  const updateHeaderHeight = () => {
    if (header) document.documentElement.style.setProperty('--header-height', Math.round(header.getBoundingClientRect().height) + 'px');
  };
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight, { passive: true });
  if (window.ResizeObserver && header) new ResizeObserver(updateHeaderHeight).observe(header);

  // Keep sibling navigation disclosure panels from obscuring one another.
  $$('.nav > .dropdown').forEach(details => details.addEventListener('toggle', () => {
    if (details.open) $$('.nav > .dropdown').forEach(other => { if (other !== details) other.open = false; });
  }));
  $$('.local-desktop .local-dropdown,.local-mobile-panel .local-dropdown').forEach(details => details.addEventListener('toggle', () => {
    if (details.open) $$('.local-dropdown', details.parentElement).forEach(other => { if (other !== details) other.open = false; });
  }));
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    $$('.local-mobile[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') $$('.local-mobile[open],.local-dropdown[open]').forEach(d => { d.open = false; });
  });

  // Full-size original images with native dialog focus trapping and Escape support.
  const lightbox = $('#media-lightbox');
  let lastImageTrigger = null;
  if (lightbox) {
    const img = $('img', lightbox);
    const close = () => { lightbox.close(); if (lastImageTrigger) lastImageTrigger.focus({ preventScroll: true }); };
    $$('[data-lightbox-src]').forEach(trigger => trigger.addEventListener('click', event => {
      event.preventDefault();
      const src = trigger.dataset.lightboxSrc;
      if (!src || /^\s*(javascript|data):/i.test(src)) return;
      if (typeof lightbox.showModal !== 'function') { location.href = src; return; }
      lastImageTrigger = trigger;
      img.src = src;
      img.alt = trigger.dataset.lightboxAlt || $('img', trigger)?.alt || 'Vergrote afbeelding';
      $('.lightbox-caption', lightbox).textContent = img.alt;
      lightbox.showModal();
      $('.lightbox-close', lightbox).focus();
    }));
    $('.lightbox-close', lightbox).addEventListener('click', close);
    lightbox.addEventListener('click', event => { if (event.target === lightbox) close(); });
    lightbox.addEventListener('cancel', event => { event.preventDefault(); close(); });
  }
  $$('[data-accordion]').forEach(group => {
    $$('details', group).forEach(d => d.addEventListener('toggle', () => {
      if (d.open) $$('details', group).forEach(other => { if (other !== d) other.open = false; });
    }));
  });
  $$('[data-reveal]').forEach(el => el.classList.add('is-visible'));

  // Retain the supplied visitor-review carousel without an external library.
  $$('[data-review-slider]').forEach(slider => {
    const viewport = $('.review-slider__viewport', slider);
    const track = $('.review-slider__track', slider);
    const cards = $$('.review-card', slider);
    const prev = $('.review-slider__button--prev', slider);
    const next = $('.review-slider__button--next', slider);
    const dots = $('.review-slider__dots', slider);
    if (!viewport || !track || !cards.length) return;
    const visible = () => innerWidth <= 680 ? 1 : innerWidth <= 1000 ? 2 : 3;
    const count = () => Math.max(1, Math.ceil(cards.length / visible()));
    let active = 0;
    const update = () => {
      active = Math.max(0, Math.min(active, count() - 1));
      if (prev) prev.disabled = active === 0;
      if (next) next.disabled = active === count() - 1;
      if (dots) $$('button', dots).forEach((d, i) => {
        d.classList.toggle('is-active', i === active);
        d.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    };
    const go = n => {
      active = Math.max(0, Math.min(n, count() - 1));
      const card = cards[Math.min(active * visible(), cards.length - 1)];
      viewport.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: reducedMotion() ? 'auto' : 'smooth' });
      update();
    };
    const renderDots = () => {
      if (!dots) return;
      dots.replaceChildren();
      for (let i = 0; i < count(); i++) {
        const button = document.createElement('button'); button.type = 'button';
        button.className = 'review-slider__dot'; button.setAttribute('aria-label', 'Ga naar reviewpagina ' + (i + 1));
        button.addEventListener('click', () => go(i)); dots.append(button);
      }
    };
    if (prev) prev.addEventListener('click', () => go(active - 1));
    if (next) next.addEventListener('click', () => go(active + 1));
    let scrollTimer;
    viewport.addEventListener('scroll', () => { clearTimeout(scrollTimer); scrollTimer = setTimeout(() => { active = Math.round(viewport.scrollLeft / Math.max(1, viewport.clientWidth)); update(); }, 100); }, { passive: true });
    window.addEventListener('resize', () => { renderDots(); go(active); }, { passive: true });
    renderDots(); update();
  });

  // Any preserved countdown has a deterministic, non-negative fallback.
  $$('[data-countdown]').forEach(node => {
    const target = Date.parse(node.dataset.countdown || '');
    if (!Number.isFinite(target)) return;
    const update = () => {
      const seconds = Math.max(0, Math.floor((target - Date.now()) / 1000));
      const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
      Object.entries(values).forEach(([key, value]) => { const el = $('[data-' + key + ']', node); if (el) el.textContent = String(value).padStart(key === 'days' ? 3 : 2, '0'); });
      if (!seconds) node.setAttribute('aria-label', 'Deze festivaldatum is bereikt.');
    };
    update(); setInterval(update, 1000);
  });

  const feedback = $('#feedback-form');
  if (feedback) {
    const submit = $('button[type="submit"]', feedback);
    if (submit) submit.textContent = 'Maak e-mailconcept';
    const status = $('#feedback-form-status');
    const fields = $('fieldset', feedback); if (fields) fields.disabled = false;
    if (status) status.textContent = 'Dit formulier maakt een e-mailconcept. Er wordt niets automatisch verstuurd.';
    feedback.addEventListener('submit', event => {
      event.preventDefault(); if (!feedback.reportValidity()) return;
      const data = new FormData(feedback);
      const clean = value => String(value || '').replace(/[\r\n\u0000-\u001f]/g, ' ').slice(0, 300);
      const recipient = 'info@ketikoti-connect.nl';
      const subject = 'Feedback Festival Wijkpark | ' + clean(data.get('role') || 'Algemene festivalervaring');
      const body = ['Naam: ' + clean(data.get('name') || 'Anoniem'), 'E-mailadres: ' + clean(data.get('email') || 'Niet opgegeven'), 'Rol: ' + clean(data.get('role')), 'Algemene waardering: ' + clean(data.get('rating')), '', 'Wat waardeerde u het meest?', String(data.get('positive') || '').trim(), '', 'Wat kan volgens u beter?', String(data.get('improvement') || '').trim(), '', 'Toestemming: uitsluitend gebruik voor evaluatie en beantwoording van deze feedback.'].join('\n');
      let result = $('.feedback-draft', feedback);
      if (!result) { result = document.createElement('div'); result.className = 'feedback-draft'; feedback.append(result); }
      result.replaceChildren();
      const heading = document.createElement('h3'); heading.textContent = 'Je concept staat klaar.'; heading.tabIndex = -1;
      const note = document.createElement('p'); note.textContent = 'Het bericht is nog niet verstuurd. Controleer de tekst en verzend deze zelf vanuit je e-mailprogramma.';
      const text = document.createElement('textarea'); text.readOnly = true; text.setAttribute('aria-label', 'Feedbackconcept'); text.value = 'Aan: ' + recipient + '\nOnderwerp: ' + subject + '\n\n' + body;
      const link = document.createElement('a'); link.className = 'button button--primary'; link.textContent = 'Open e-mailprogramma'; link.href = 'mailto:' + recipient + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      result.append(heading, note, text, link); heading.focus({ preventScroll: true }); result.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'nearest' });
      if (status) status.textContent = 'E-mailconcept aangemaakt. Nog niet verstuurd.';
    });
  }

  // Preserve the existing Elfsight app, but load it only after an explicit choice.
  const help = $('#help-dialog');
  let widgetLoaded = false;
  let widgetLoading = false;
  let helpTrigger = null;
  let generation = 0;
  if (help) {
    $$('[data-help-open]').forEach(btn => btn.addEventListener('click', () => { helpTrigger = btn; help.showModal(); $('.help-close', help).focus(); }));
    const closeHelp = () => { help.close(); if (helpTrigger) helpTrigger.focus({ preventScroll: true }); };
    $('.help-close', help).addEventListener('click', closeHelp);
    help.addEventListener('cancel', event => { event.preventDefault(); closeHelp(); });
    help.addEventListener('click', event => { if (event.target === help) closeHelp(); });
    const loadButton = $('[data-load-widget]', help);
    loadButton.addEventListener('click', () => {
      const status = $('[data-widget-status]', help);
      if (widgetLoaded) { closeHelp(); return; }
      if (widgetLoading) return;
      widgetLoading = true; loadButton.disabled = true;
      const attempt = ++generation;
      let holder = document.querySelector('.elfsight-app-bccffe77-7c36-4ef1-80c3-d345cf1f43b8');
      if (!holder) { holder = document.createElement('div'); holder.className = 'elfsight-app-bccffe77-7c36-4ef1-80c3-d345cf1f43b8'; holder.setAttribute('data-elfsight-app-lazy', ''); document.body.append(holder); }
      const script = document.createElement('script'); script.src = 'https://elfsightcdn.com/platform.js'; script.async = true;
      status.textContent = 'De externe websitehulp wordt geladen...';
      const fail = () => { if (attempt !== generation || !widgetLoading) return; clearTimeout(timer); ++generation; widgetLoading = false; loadButton.disabled = false; status.textContent = 'De externe websitehulp is niet bereikbaar. Probeer opnieuw of neem contact op via info@ketikoti-connect.nl.'; script.onload = script.onerror = null; script.remove(); };
      const timer = setTimeout(fail, 15000);
      script.onload = () => { if (attempt !== generation) return; clearTimeout(timer); widgetLoading = false; widgetLoaded = true; loadButton.disabled = false; status.textContent = 'De externe websitehulp is geladen.'; closeHelp(); };
      script.onerror = fail;
      document.body.append(script);
    });
  }
  const top = $('.back-top');
  if (top) {
    const update = () => { top.hidden = scrollY < 700; };
    update(); window.addEventListener('scroll', update, { passive: true });
    top.addEventListener('click', () => { window.scrollTo({ top: 0, behavior: reducedMotion() ? 'auto' : 'smooth' }); });
  }
})();
